var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"empty"},[_c('div',{staticClass:"text"},[_c('NoneIcon',{staticClass:"icon"}),_c('p',[_vm._v("Currently you do not have any appointments")])],1),_c('router-link',{attrs:{"to":"/"}},[_vm._v(" Go Back ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }